import StudentPanelsConfig from '../../student-container/student-panels.config';

const AcademicPanelEMSConfig = {
  title: StudentPanelsConfig.ACADEMIC.human,
  paths: ['assmnts.summary', 'assmnts.history', 'isHS', 'isMS', 'isES', 'activeStudentSupports', 'currProgram'],
};

export default AcademicPanelEMSConfig;
